import { render } from "./ProviderManagementList.vue?vue&type=template&id=9da80f64&scoped=true"
import script from "./ProviderManagementList.vue?vue&type=script&lang=js"
export * from "./ProviderManagementList.vue?vue&type=script&lang=js"

import "./ProviderManagementList.vue?vue&type=style&index=0&id=9da80f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da80f64"]])

export default __exports__